module.exports = __webpack_public_path__ + "img/CheckCircle.e8c020be.svg";